const Loader = () => {
  return (
    <div
      className="text-center"
      style={{ color: 'var(--custom-primary-color)' }}
    >
      <div className="spinner-border" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};

export default Loader;
